import { useState } from 'react'

import ArrowBackIcon from '@mui/icons-material/ArrowBack'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import Box from '@mui/material/Box'
import Breadcrumbs from '@mui/material/Breadcrumbs'
import Button from '@mui/material/Button'
import Card from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import Container from '@mui/material/Container'
import Grid from '@mui/material/Grid'
import Link from '@mui/material/Link'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import { useMutation } from '@tanstack/react-query'
import { ROUTES } from 'constants/routes'
import { useGlobalState } from 'contexts/global-state'
import { useForm } from 'react-hook-form'
import { useNavigate } from 'react-router-dom'
import { ApiService } from 'services/api'

export default function ListWebhookPix() {
  const navigate = useNavigate()
  const { openErrorToast } = useGlobalState()
  const [responseData, setResponseData] = useState<unknown | null>(null)

  const {
    register,
    formState: { errors },
    handleSubmit,
  } = useForm<InterReservationListWebhookPixApiRequest>()

  const listWebhookPix = useMutation({
    mutationFn: async (data: InterReservationListWebhookPixApiRequest) => {
      const response = await ApiService.InterReservation.listWebhookPix(data)
      return response
    },
    onSuccess: (data) => {
      setResponseData(data)
    },
    onError: () => {
      openErrorToast({
        message: 'Erro ao listar webhooks PIX!',
      })
    },
  })

  return (
    <Box component="main" sx={{ flexGrow: 1, py: 8 }}>
      <Container maxWidth={false}>
        <Breadcrumbs
          aria-label="breadcrumb"
          separator={<NavigateNextIcon fontSize="small" />}
        >
          <Link
            underline="hover"
            color="inherit"
            href={ROUTES.INTER_RESERVATION.LIST_WEBHOOK_PIX}
          >
            Inter Reservervation
          </Link>
          <Typography color="text.primary">Listar Webhooks PIX</Typography>
        </Breadcrumbs>

        <Box
          sx={{
            alignItems: 'center',
            display: 'flex',
            justifyContent: 'space-between',
          }}
        >
          <Box
            sx={{
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <ArrowBackIcon
              style={{ cursor: 'pointer' }}
              onClick={() => {
                navigate(-1)
              }}
            />
            <Typography sx={{ m: 1 }} variant="h4">
              Listar Webhooks PIX
            </Typography>
          </Box>
        </Box>

        <Box sx={{ mt: 3 }}>
          <form
            onSubmit={handleSubmit(
              (data: InterReservationListWebhookPixApiRequest) => {
                listWebhookPix.mutate(data)
              },
            )}
          >
            <Card>
              <CardContent>
                <Grid container spacing={3} xs={12}>
                  <Grid item xs={6}>
                    <TextField
                      error={!!errors.chave?.message}
                      fullWidth
                      helperText={errors.chave?.message}
                      label="Chave"
                      margin="normal"
                      variant="outlined"
                      {...register('chave', { required: true })}
                    />
                  </Grid>
                </Grid>

                <Box>
                  <Button
                    type="submit"
                    color="primary"
                    variant="contained"
                    style={{
                      marginLeft: 'auto',
                      display: 'block',
                      marginTop: '1em',
                    }}
                  >
                    Listar
                  </Button>
                </Box>
              </CardContent>
            </Card>
          </form>

          {responseData !== null && (
            <Card sx={{ mt: 3 }}>
              <CardContent>
                <Typography variant="h6" sx={{ mb: 2 }}>
                  Resposta
                </Typography>
                <Box
                  component="pre"
                  sx={{
                    backgroundColor: '#f5f5f5',
                    p: 2,
                    borderRadius: 1,
                    overflow: 'auto',
                    maxHeight: 500,
                    fontSize: '0.875rem',
                  }}
                >
                  {JSON.stringify(responseData, null, 2)}
                </Box>
              </CardContent>
            </Card>
          )}
        </Box>
      </Container>
    </Box>
  )
}
